import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=4f78dce2&"
import script from "./MediaGallery.vue?vue&type=script&lang=js&"
export * from "./MediaGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports